import { I18nExtended } from '~i18n-extended/class'

export default (ctx) => {
  const i18nExtendedInstance = new I18nExtended(ctx)

  ctx.app.router.afterEach(
    (to, from) => i18nExtendedInstance.handleRouteChange(to, from))
}
